export default __webpack_public_path__ + "static/media/caroline.312562e7.png";